import * as React from "react";
import { useEffect, useState } from "react";
import { useAPI } from "../api/API";

const Dashboard = () => {
    const [sections, setSections] = useState([]);
    const api = useAPI();

    useEffect(() => {
        api.distributionsInfo().then((data) => {
            setSections(data);
        }).catch(console.error);
    }, [api]);

    return (
        <>
            <div className="background"></div>
            <div className="dash-container">
                <div className="notch-container">
                    <div className="notch"></div>
                    <div className="container full-height">
                        <h1>
                            Для начала работы с Квадросимом необходимо выполнить
                            следующие действия:
                        </h1>
                        <p>
                            <ul>
                                <li>1. Скачать архив с симулятором</li>
                                <li>2. Распаковать архив в желаемую папку</li>
                                <li>
                                    3. Запустить симулятор через исполняемый
                                    файл в папке с симулятором
                                </li>
                                <li>
                                    4.{" "}
                                    <a
                                        href="https://cdn-s3.quadrosim.ru/guides/QSim%20user%20guide%20v1.14.pdf"
                                        className="instruction-main"
                                    >
                                        Познакомьтесь с руководством
                                        пользователя
                                    </a>
                                </li>
                            </ul>
                        </p>
                        <p>
                            В случае, если на одном компьютере необходимо
                            установить две версии Квадросима, в том числе разных
                            лицензий, воспользуйтесь установочным файлом
                            Квадросим Экстра
                        </p>

                        <p>
                            Обратите внимание, что вторая версия симулятора
                            будет работать обособленно от первой, включая данные
                            лицензии, профили пользователя, импортируемый и
                            экспортируемый контент и т.д.
                        </p>
                    </div>
                    <div className="notch-after"></div>
                </div>
                {sections.map((section, index) => (
                    <React.Fragment key={index}>
                        <div className="table-title">
                            <span className="t-title">{section.version_display_name}</span>
                        </div>
                        <div className="table-container">
                            <table>
                                <thead>
                                <tr>
                                    <th>Версия</th>
                                    <th>ОС</th>
                                    <th>Тип Файла</th>
                                    <th>Ссылка на скачивание</th>
                                    <th>Вес</th>
                                    <th>Инструкция по установке</th>
                                </tr>
                                </thead>
                                <tbody>
                                {section.distributions.map((o) => (
                                    <tr key={`${o.version}-${o.os}-${index}`}>
                                        <td>{o.version}</td>
                                        <td translate={"no"}>{o.os}</td>
                                        <td translate={"no"}>{o.extension}</td>
                                        <td>
                                            <a href={o.get_distributive_url}>
                                                Скачать
                                            </a>
                                        </td>
                                        <td>{o.file_weight}</td>
                                        <td>
                                            <a href={o.get_instruction_url}>
                                                Инструкция
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </>
    );
};

export default Dashboard;
